import * as helper from '../../../Assets/Js/helper';

export default function MuteButton(button, video) {
	let muted = true;

	helper.addEventListener(button, 'click', () => {
		muted = !muted;
		video.muted = muted;

		const svg = button.querySelector('svg');
		helper.removeClass(svg, 'fa-volume-mute');
		helper.removeClass(svg, 'fa-volume-up');

		if (muted) {
			helper.addClass(svg, 'fa-volume-mute');
		} else {
			helper.addClass(svg, 'fa-volume-up');
		}
	});

}
